module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-341.066631a.woff2";